/**
 * ETournify Premium flex match intro — Team A vs Team B.
 * One continuous stage: intro background from first paint, content animates in when ready.
 * No page-color flash. No fake PREMIUM wait copy.
 */
(function () {
  'use strict';

  window.ETN = window.ETN || {};

  var STYLE_ID = 'etn-match-intro-styles-v10';
  var ROOT_ID = 'etn-match-intro-root';
  var MAX_PREMIUM_PER_SIDE = 4;
  var MAX_REST_PER_SIDE = 5;
  var hideTimer = null;
  var leaveTimer = null;
  var settleTimer = null;
  var runningAnims = [];
  var FRAME_CENTER = 'translate(-50%, -50%)';
  window.ETN_BADGES_CIRCLE = window.ETN_BADGES_CIRCLE || {
    premium: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-01-premium.png',
    'premium-plus': 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-02-premium-plus.png',
    vip: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-03-vip.png',
    elite: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-04-elite.png',
    legendary: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-05-legendary.png',
    mythic: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-06-mythic.png',
    champion: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-07-champion.png',
    'tournament-king': 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-08-tournament-king.png',
    icon: 'https://etournify.com/cdn/shop/t/2/assets/etn-badge-circle-09-icon.png'
  };

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function cropStyle(player) {
    if (window.ETN && typeof window.ETN.avatarCropStyle === 'function') {
      return window.ETN.avatarCropStyle(player);
    }
    return 'width:100%;height:100%;object-fit:cover;display:block;';
  }

  function ensureStyles() {
    try {
      var stale = document.querySelectorAll('style[id^="etn-match-intro-styles"]');
      for (var si = 0; si < stale.length; si++) {
        if (stale[si].id !== STYLE_ID && stale[si].parentNode) stale[si].parentNode.removeChild(stale[si]);
      }
    } catch (eStale) {}
    var style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }
    style.textContent =
      'body.etn-mi-pending{overflow:hidden!important}' +
      'body.etn-mi-pending .shopify-section-group-header-group,' +
      'body.etn-mi-pending .shopify-section-group-footer-group,' +
      'body.etn-mi-pending footer,' +
      'body.etn-mi-pending #shopify-section-header{' +
      'visibility:hidden!important;pointer-events:none!important}' +
      '#' + ROOT_ID + '{' +
      'position:fixed;inset:0;z-index:2147483000;' +
      'display:none;align-items:center;justify-content:center;' +
      'overflow:hidden;background:#050508;opacity:0;pointer-events:none;' +
      '-webkit-transform:translateZ(0);transform:translateZ(0);' +
      '}' +
      '#' + ROOT_ID + '.is-on{' +
      'display:-webkit-flex!important;display:flex!important;opacity:1;pointer-events:auto;' +
      '}' +
      '#' + ROOT_ID + '.is-off{display:none!important;opacity:0;pointer-events:none}' +
      '#' + ROOT_ID + '.is-leaving{' +
      'opacity:0!important;' +
      '-webkit-transition:opacity .65s ease;transition:opacity .65s ease;' +
      'pointer-events:none;' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-veil{position:absolute;inset:0;background:' +
      'radial-gradient(ellipse 55% 42% at 50% 42%,rgba(124,58,237,.2),transparent 58%),' +
      'radial-gradient(ellipse 80% 60% at 50% 100%,rgba(49,20,92,.45),transparent 58%),' +
      'linear-gradient(180deg,#050508 0%,#0a0812 48%,#050508 100%)}' +
      '#' + ROOT_ID + ' .etn-mi-burst{position:absolute;left:50%;top:44%;width:min(70vw,520px);height:min(70vw,520px);' +
      'margin:0;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);opacity:.3;pointer-events:none;' +
      'background:radial-gradient(circle at center,rgba(167,139,250,.2) 0%,rgba(124,58,237,.14) 28%,rgba(76,29,149,.12) 48%,transparent 68%)}' +
      '#' + ROOT_ID + ' .etn-mi-card{position:relative;z-index:2;width:min(96vw,1040px);padding:0 18px;text-align:center;' +
      'will-change:opacity,transform}' +
      '#' + ROOT_ID + ' .etn-mi-chip{display:inline-block;margin:0 auto 20px;padding:7px 14px;border:1px solid rgba(245,208,122,.48);' +
      'color:#f5d07a;font-size:clamp(11px,1.3vw,13px);font-weight:800;letter-spacing:.18em;text-transform:uppercase;' +
      'background:linear-gradient(180deg,rgba(245,208,122,.15),rgba(245,208,122,.04));' +
      'will-change:opacity,transform}' +
      '#' + ROOT_ID + ' .etn-mi-duel{display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);' +
      'gap:14px 32px;align-items:center;justify-items:center}' +
      '#' + ROOT_ID + ' .etn-mi-side{display:flex;align-items:center;justify-content:center;width:100%;min-width:0}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a{justify-content:flex-end}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b{justify-content:flex-start}' +
      '#' + ROOT_ID + ' .etn-mi-row{display:flex;flex-direction:row;flex-wrap:nowrap;align-items:flex-start;justify-content:center;gap:14px 16px;max-width:100%}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a .etn-mi-row{justify-content:flex-end}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b .etn-mi-row{justify-content:flex-start}' +
      '#' + ROOT_ID + ' .etn-mi-mid{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:9px;' +
      'min-width:84px;padding:0 5px;will-change:opacity,transform}' +
      '#' + ROOT_ID + ' .etn-mi-vs{color:#f5d07a;font-size:clamp(26px,4.5vw,42px);font-weight:950;letter-spacing:.1em;line-height:1}' +
      '#' + ROOT_ID + ' .etn-mi-mid-label{color:rgba(221,214,254,.88);font-size:clamp(11px,1.4vw,13px);font-weight:800;letter-spacing:.18em;text-transform:uppercase}' +
      '#' + ROOT_ID + ' .etn-mi-player{width:108px;flex:0 0 auto;display:flex;flex-direction:column;align-items:center;gap:7px;' +
      'overflow:visible;will-change:opacity,transform}' +
      '#' + ROOT_ID + ' .etn-mi-stage{position:relative;width:90px;height:90px;overflow:visible}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-pfp-wrap{position:absolute;inset:0;display:block;overflow:visible;line-height:0}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-prem-frame{position:absolute;top:50%;left:50%;width:198.67%;height:198.67%;' +
      'transform:translate(-50%,-50%);z-index:6;pointer-events:none;line-height:0;will-change:opacity,transform}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-prem-frame img{width:100%;height:100%;display:block;filter:drop-shadow(0 2px 6px rgba(0,0,0,.45))}' +
      '#' + ROOT_ID + ' .etn-mi-avatar{position:absolute;inset:0;border-radius:50%;overflow:hidden;background:#14101f;' +
      'border:3px solid rgba(196,181,253,.58);box-shadow:0 12px 28px rgba(0,0,0,.52)}' +
      '#' + ROOT_ID + ' .etn-has-frame .etn-mi-avatar{border:0;box-shadow:0 12px 28px rgba(0,0,0,.52)}' +
      '#' + ROOT_ID + ' .etn-mi-avatar img{width:100%;height:100%;object-fit:cover;display:block;border-radius:50%}' +
      '#' + ROOT_ID + ' .etn-mi-avatar .etn-mi-fallback{width:100%;height:100%;display:flex;align-items:center;justify-content:center;' +
      'background:#1a1528;color:#ddd6fe;font-weight:800;font-size:30px;border-radius:50%}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-premium .etn-mi-stage{margin-bottom:8px}' +
      '#' + ROOT_ID + ' .etn-mi-name{max-width:108px;font-size:clamp(13px,1.5vw,15px);font-weight:800;color:#fff;line-height:1.2;word-break:break-word;' +
      'position:relative;z-index:7}' +
      '#' + ROOT_ID + ' .etn-mi-title{max-width:108px;min-height:1.2em;color:#f5d07a;font-size:clamp(10px,1.2vw,12px);font-weight:800;letter-spacing:.06em;text-transform:uppercase;line-height:1.2;' +
      'position:relative;z-index:7}' +
      '#' + ROOT_ID + ' .etn-mi-title:empty{display:none}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest{width:88px;flex:0 0 auto;gap:6px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-stage{width:70px;height:70px;margin-top:10px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-avatar{border-width:2.5px;border-color:rgba(196,181,253,.5);' +
      'box-shadow:0 9px 20px rgba(0,0,0,.44)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-avatar .etn-mi-fallback{font-size:23px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-name{max-width:88px;font-size:clamp(12px,1.4vw,14px);color:rgba(255,255,255,.88)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-normal .etn-mi-avatar{border-color:rgba(196,181,253,.58);' +
      'box-shadow:0 12px 28px rgba(0,0,0,.48)}' +
      '#' + ROOT_ID + ' .etn-mi-more{align-self:flex-end;margin-bottom:20px;color:rgba(245,208,122,.9);font-size:13px;font-weight:800;' +
      'letter-spacing:.04em;padding:7px 10px;border:1px solid rgba(245,208,122,.38);border-radius:999px}' +
      '#' + ROOT_ID + ' .etn-mi-foot{margin-top:24px;color:rgba(221,214,254,.88);font-size:clamp(12px,1.5vw,14px);font-weight:800;letter-spacing:.18em;' +
      'text-transform:uppercase;will-change:opacity,transform}' +
      '#' + ROOT_ID + ' .etn-mi-foot:empty{display:none}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-veil{background:' +
      'radial-gradient(ellipse 55% 42% at 50% 42%,rgba(109,40,217,.28),transparent 58%),' +
      'radial-gradient(ellipse 80% 60% at 50% 100%,rgba(46,16,101,.55),transparent 58%),' +
      'linear-gradient(180deg,#050508 0%,#0a0812 48%,#050508 100%)}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-burst{' +
      'background:radial-gradient(circle at center,rgba(139,92,246,.28) 0%,rgba(109,40,217,.18) 28%,rgba(76,29,149,.14) 48%,transparent 68%);' +
      'opacity:.38}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-chip{border-color:rgba(109,40,217,.75);color:#7c3aed;' +
      'background:linear-gradient(180deg,rgba(109,40,217,.28),rgba(49,20,92,.14));' +
      'box-shadow:0 0 18px rgba(109,40,217,.25)}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-vs{color:#6d28d9;' +
      'text-shadow:0 0 22px rgba(109,40,217,.55),0 0 4px rgba(76,29,149,.4)}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-mid-label{color:rgba(124,58,237,.9)}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-foot{color:rgba(109,40,217,.88)}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-more{color:rgba(139,92,246,.95);border-color:rgba(109,40,217,.55)}' +
      '#' + ROOT_ID + '.is-lobby .etn-mi-avatar{border-color:rgba(124,58,237,.7);' +
      'box-shadow:0 12px 28px rgba(0,0,0,.52),0 0 22px rgba(109,40,217,.28)}' +
      '@media (min-width:901px){' +
      '#' + ROOT_ID + '{align-items:center;justify-content:center;padding:0}' +
      '#' + ROOT_ID + ' .etn-mi-card{' +
      'width:min(96vw,1040px);min-height:0;height:auto;padding:0 18px;' +
      'display:block;justify-content:initial;gap:0' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-duel{' +
      'display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);' +
      'gap:14px 32px;align-items:center;justify-items:center;width:auto;flex:none' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-row,' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a .etn-mi-row,' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b .etn-mi-row{' +
      'flex-direction:row;flex-wrap:nowrap;align-items:flex-start;gap:14px 16px' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a .etn-mi-row{justify-content:flex-end}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b .etn-mi-row{justify-content:flex-start}' +
      '#' + ROOT_ID + ' .etn-mi-mid{max-width:none;width:auto;min-width:84px;padding:0 5px;gap:9px}' +
      '#' + ROOT_ID + ' .etn-mi-vs{font-size:clamp(26px,4.5vw,42px)}' +
      '#' + ROOT_ID + ' .etn-mi-mid-label{font-size:clamp(11px,1.4vw,13px);max-width:none;letter-spacing:.18em}' +
      '#' + ROOT_ID + ' .etn-mi-player{width:108px}' +
      '#' + ROOT_ID + ' .etn-mi-stage{width:90px;height:90px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest{width:88px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-stage{width:70px;height:70px;margin-top:10px}' +
      '#' + ROOT_ID + ' .etn-mi-name{max-width:108px;font-size:clamp(13px,1.5vw,15px)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-name{max-width:88px;font-size:clamp(12px,1.4vw,14px)}' +
      '#' + ROOT_ID + ' .etn-mi-foot{margin-top:24px;padding:0;font-size:clamp(12px,1.5vw,14px);letter-spacing:.18em}' +
      '#' + ROOT_ID + ' .etn-mi-chip{margin:0 auto 20px;padding:7px 14px;font-size:clamp(11px,1.3vw,13px)}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-prem-frame{width:198.67%;height:198.67%}' +
      '}' +
      '@media (min-width:721px) and (max-width:900px){' +
      '#' + ROOT_ID + '{align-items:center;justify-content:center;padding:0}' +
      '#' + ROOT_ID + ' .etn-mi-card{' +
      'width:min(96vw,1040px);min-height:0;height:auto;padding:0 16px;' +
      'display:block;justify-content:initial;gap:0' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-duel{' +
      'display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);' +
      'gap:12px 18px;width:auto;flex:none' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-row,' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a .etn-mi-row,' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b .etn-mi-row{' +
      'flex-direction:row;flex-wrap:nowrap;align-items:flex-start;gap:12px 14px' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a .etn-mi-row{justify-content:flex-end}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b .etn-mi-row{justify-content:flex-start}' +
      '#' + ROOT_ID + ' .etn-mi-mid{max-width:none;min-width:72px;padding:0 4px}' +
      '#' + ROOT_ID + ' .etn-mi-vs{font-size:clamp(24px,4vw,36px)}' +
      '#' + ROOT_ID + ' .etn-mi-mid-label{max-width:none;font-size:12px}' +
      '#' + ROOT_ID + ' .etn-mi-player{width:96px}' +
      '#' + ROOT_ID + ' .etn-mi-stage{width:80px;height:80px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest{width:78px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-stage{width:64px;height:64px}' +
      '#' + ROOT_ID + ' .etn-mi-name{max-width:96px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-name{max-width:78px}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-prem-frame{width:198.67%;height:198.67%}' +
      '#' + ROOT_ID + ' .etn-mi-foot{margin-top:20px;padding:0}' +
      '#' + ROOT_ID + ' .etn-mi-chip{margin:0 auto 16px}' +
      '}' +
      '@media (max-width:720px){' +
      '#' + ROOT_ID + '{' +
      'align-items:stretch;justify-content:center;' +
      'padding:max(10px,env(safe-area-inset-top)) 0 max(12px,env(safe-area-inset-bottom))' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-card{' +
      'width:100%;max-width:100%;min-height:min(100dvh,100vh);box-sizing:border-box;' +
      'padding:16px 12px 18px;display:flex;flex-direction:column;align-items:center;' +
      'justify-content:space-between;gap:14px' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-chip{' +
      'margin:0 auto;padding:9px 14px;font-size:11px;letter-spacing:.14em;flex-shrink:0;' +
      'max-width:calc(100% - 16px);box-sizing:border-box' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-duel{' +
      'display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr);' +
      'gap:10px 8px;align-items:center;justify-items:center;width:100%;' +
      'flex:1 1 auto;min-height:0' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-side{width:100%;min-width:0;align-items:center}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a{justify-content:flex-end}' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b{justify-content:flex-start}' +
      '#' + ROOT_ID + ' .etn-mi-row,' +
      '#' + ROOT_ID + ' .etn-mi-side.is-a .etn-mi-row,' +
      '#' + ROOT_ID + ' .etn-mi-side.is-b .etn-mi-row{' +
      'flex-direction:column;flex-wrap:nowrap;align-items:center;justify-content:center;' +
      'gap:18px;width:100%;max-width:100%' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-mid{' +
      'order:0;min-width:0;width:auto;max-width:34vw;padding:4px 2px;gap:10px;flex-shrink:0;' +
      'align-self:center' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-vs{font-size:clamp(28px,9vw,40px);letter-spacing:.08em}' +
      '#' + ROOT_ID + ' .etn-mi-mid-label{' +
      'font-size:clamp(10px,2.8vw,12px);letter-spacing:.12em;line-height:1.35;' +
      'max-width:34vw' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-player{width:min(92px,28vw);gap:6px}' +
      '#' + ROOT_ID + ' .etn-mi-stage{width:min(80px,24vw);height:min(80px,24vw)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest{width:min(78px,24vw)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-stage{' +
      'width:min(64px,20vw);height:min(64px,20vw);margin-bottom:4px' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-name{max-width:min(92px,28vw);font-size:12px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-name{max-width:min(78px,24vw);font-size:11px}' +
      '#' + ROOT_ID + ' .etn-mi-title{max-width:min(92px,28vw);font-size:10px}' +
      '#' + ROOT_ID + ' .etn-mi-avatar .etn-mi-fallback{font-size:26px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-avatar .etn-mi-fallback{font-size:22px}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-prem-frame{width:198.67%;height:198.67%}' +
      '#' + ROOT_ID + ' .etn-mi-foot{' +
      'margin-top:0;padding:0 10px;font-size:12px;letter-spacing:.14em;flex-shrink:0;' +
      'max-width:100%;line-height:1.35' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-more{margin-bottom:0;align-self:center}' +
      '}' +
      '@media (max-width:380px){' +
      '#' + ROOT_ID + ' .etn-mi-card{padding:12px 8px 14px;gap:10px}' +
      '#' + ROOT_ID + ' .etn-mi-duel{gap:8px 4px}' +
      '#' + ROOT_ID + ' .etn-mi-row{gap:14px}' +
      '#' + ROOT_ID + ' .etn-mi-player{width:min(84px,30vw)}' +
      '#' + ROOT_ID + ' .etn-mi-stage{width:min(72px,26vw);height:min(72px,26vw)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest{width:min(70px,26vw)}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-stage{width:min(58px,22vw);height:min(58px,22vw)}' +
      '#' + ROOT_ID + ' .etn-mi-vs{font-size:clamp(24px,8vw,34px)}' +
      '#' + ROOT_ID + ' .etn-mi-mid{max-width:32vw}' +
      '#' + ROOT_ID + ' .etn-mi-mid-label{max-width:32vw;font-size:10px}' +
      '}' +
      '@media (max-width:720px) and (max-height:480px){' +
      '#' + ROOT_ID + '{padding:6px 0}' +
      '#' + ROOT_ID + ' .etn-mi-card{' +
      'min-height:0;height:auto;padding:8px 12px;justify-content:center;gap:8px' +
      '}' +
      '#' + ROOT_ID + ' .etn-mi-duel{flex:0 0 auto;gap:6px 8px}' +
      '#' + ROOT_ID + ' .etn-mi-row{gap:10px}' +
      '#' + ROOT_ID + ' .etn-mi-player{width:58px}' +
      '#' + ROOT_ID + ' .etn-mi-stage{width:48px;height:48px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest{width:50px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-stage{width:40px;height:40px;margin-bottom:2px}' +
      '#' + ROOT_ID + ' .etn-mi-name{max-width:58px;font-size:10px}' +
      '#' + ROOT_ID + ' .etn-mi-player.is-rest .etn-mi-name{max-width:50px;font-size:9px}' +
      '#' + ROOT_ID + ' .etn-mi-vs{font-size:22px}' +
      '#' + ROOT_ID + ' .etn-mi-mid{max-width:28vw;gap:4px}' +
      '#' + ROOT_ID + ' .etn-mi-mid-label{max-width:28vw;font-size:9px}' +
      '#' + ROOT_ID + ' .etn-mi-stage .etn-prem-frame{width:198.67%;height:198.67%}' +
      '#' + ROOT_ID + ' .etn-mi-chip{padding:5px 10px;font-size:10px}' +
      '#' + ROOT_ID + ' .etn-mi-foot{font-size:10px;padding:0}' +
      '}';
  }

  var INTRO_I18N = {
    bg: {
      'A crown rises': 'Изгрява корона',
      Battle: 'Битка',
      'Crowns collide': 'Корони се сблъскват',
      'Good luck': 'Успех',
      'Match lobby': 'Мач лоби',
      'Premium battle': 'Premium битка',
      'Premium exclusive': 'Само за Premium',
      'Premium present': 'Premium присъства',
      VS: 'СРЕЩУ'
    },
    es: {
      'A crown rises': 'Una corona se alza',
      Battle: 'Batalla',
      'Crowns collide': 'Las coronas chocan',
      'Good luck': 'Buena suerte',
      'Match lobby': 'Lobby del partido',
      'Premium battle': 'Batalla Premium',
      'Premium exclusive': 'Exclusivo Premium',
      'Premium present': 'Premium presente',
      VS: 'VS'
    },
    fr: {
      'A crown rises': "Une couronne s'élève",
      Battle: 'Combat',
      'Crowns collide': "Les couronnes s'affrontent",
      'Good luck': 'Bonne chance',
      'Match lobby': 'Lobby du match',
      'Premium battle': 'Combat Premium',
      'Premium exclusive': 'Exclusif Premium',
      'Premium present': 'Premium présent',
      VS: 'CONTRE'
    },
    de: {
      'A crown rises': 'Eine Krone steigt auf',
      Battle: 'Kampf',
      'Crowns collide': 'Kronen kollidieren',
      'Good luck': 'Viel Glück',
      'Match lobby': 'Match-Lobby',
      'Premium battle': 'Premium-Kampf',
      'Premium exclusive': 'Premium exklusiv',
      'Premium present': 'Premium anwesend',
      VS: 'VS'
    },
    ko: {
      'A crown rises': '왕관이 떠오른다',
      Battle: '배틀',
      'Crowns collide': '왕관의 충돌',
      'Good luck': '건승',
      'Match lobby': '매치 로비',
      'Premium battle': '프리미엄 배틀',
      'Premium exclusive': '프리미엄 전용',
      'Premium present': '프리미엄 참가',
      VS: 'VS'
    },
    zh: {
      'A crown rises': '王冠升起',
      Battle: '对战',
      'Crowns collide': '王冠对决',
      'Good luck': '祝你好运',
      'Match lobby': '对战大厅',
      'Premium battle': 'Premium 对战',
      'Premium exclusive': 'Premium 专属',
      'Premium present': 'Premium 在场',
      VS: 'VS'
    }
  };

  function introLang() {
    try {
      if (window.ETN && typeof window.ETN.getLanguage === 'function') {
        return String(window.ETN.getLanguage() || 'en').toLowerCase();
      }
    } catch (e1) {}
    try {
      var saved = localStorage.getItem('etn_language');
      if (saved) return String(saved).toLowerCase().split('-')[0];
    } catch (e2) {}
    return 'en';
  }

  function miT(text) {
    var key = String(text || '').replace(/\s+/g, ' ').trim();
    if (!key) return text;
    var lang = introLang();
    if (lang && lang !== 'en' && INTRO_I18N[lang] && INTRO_I18N[lang][key]) {
      return INTRO_I18N[lang][key];
    }
    if (window.ETN && typeof window.ETN.t === 'function') {
      try {
        return window.ETN.t(key);
      } catch (e) {}
    }
    return key;
  }

  function isPremiumPlayer(player) {
    return !!(
      player &&
      (player.is_premium === true ||
        player.is_premium === 1 ||
        player.is_premium === 'true' ||
        player.is_premium === '1')
    );
  }

  function premiumPlayers(list) {
    var out = [];
    var arr = Array.isArray(list) ? list : [];
    for (var i = 0; i < arr.length; i++) {
      if (isPremiumPlayer(arr[i])) out.push(arr[i]);
    }
    return out;
  }

  function restPlayers(list) {
    var out = [];
    var arr = Array.isArray(list) ? list : [];
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] && !isPremiumPlayer(arr[i])) out.push(arr[i]);
    }
    return out;
  }

  function playerCardHtml(player, mode) {
    // mode: 'premium' | 'rest' | 'normal'
    var isPremium = mode === 'premium';
    var isRest = mode === 'rest';
    var username = String((player && player.username) || 'Player').trim() || 'Player';
    var avatar = String((player && player.avatar_url) || '').trim();
    var title = isPremium ? String((player && player.active_title) || '').trim() : '';
    var initial = esc((username.charAt(0) || '?').toUpperCase());
    var av = avatar
      ? '<img src="' + esc(avatar) + '" alt="' + esc(username) + '" style="' + cropStyle(player) + '">'
      : '<span class="etn-mi-fallback">' + initial + '</span>';

    var badgeKey =
      (player && player.badge && (player.badge.key || player.badge.badge_key)) ||
      (player && player.badge_key) ||
      'premium';
    var art = window.ETN_BADGES_CIRCLE || {};
    var badgeSrc = art[badgeKey] || art.premium || '';
    var frame = window.ETN && typeof window.ETN.premiumBadgeHtml === 'function'
      ? window.ETN.premiumBadgeHtml(badgeKey)
      : '<span class="etn-prem-frame" data-badge-key="' + esc(badgeKey) + '" aria-hidden="true">' +
        (badgeSrc ? '<img alt="" src="' + esc(badgeSrc) + '" decoding="async" draggable="false">' : '') +
        '</span>';
    var stageInner = isPremium
      ? '<span class="etn-pfp-wrap is-premium etn-has-frame">' +
        '<div class="etn-mi-avatar">' + av + '</div>' +
        frame +
        '</span>'
      : '<div class="etn-mi-avatar">' + av + '</div>';

    var cls = 'etn-mi-player';
    if (isPremium) cls += ' is-premium';
    if (isRest) cls += ' is-rest';
    else if (!isPremium) cls += ' is-normal';

    return (
      '<div class="' + cls + '">' +
      '<div class="etn-mi-stage">' +
      stageInner +
      '</div>' +
      '<div class="etn-mi-name" data-etn-i18n-skip>' + esc(username) + '</div>' +
      (isPremium
        ? '<div class="etn-mi-title" data-etn-i18n-skip>' + esc(title) + '</div>'
        : '<div class="etn-mi-title" aria-hidden="true"></div>') +
      '</div>'
    );
  }

  function sideHtml(players, sideClass) {
    var all = Array.isArray(players) ? players : [];
    if (!all.length) {
      return '<div class="etn-mi-side ' + sideClass + '"></div>';
    }

    var featured = premiumPlayers(all);
    var rest = restPlayers(all);
    var hasPremiumOnSide = featured.length > 0;

    // One clean horizontal row: Premium first (crowned), then the rest.
    // No empty slots. No stacked mess.
    var ordered = hasPremiumOnSide ? featured.concat(rest) : all.slice();
    var maxShow = MAX_PREMIUM_PER_SIDE + MAX_REST_PER_SIDE;
    var shown = ordered.slice(0, maxShow);
    var extra = Math.max(0, ordered.length - shown.length);

    var html = '<div class="etn-mi-side ' + sideClass + '"><div class="etn-mi-row">';
    for (var i = 0; i < shown.length; i++) {
      var p = shown[i];
      var mode = 'normal';
      if (hasPremiumOnSide) {
        mode = isPremiumPlayer(p) ? 'premium' : 'rest';
      }
      html += playerCardHtml(p, mode);
    }
    if (extra > 0) html += '<div class="etn-mi-more">+' + extra + '</div>';
    html += '</div></div>';
    return html;
  }

  function ensureRoot() {
    var root = document.getElementById(ROOT_ID);
    if (root) {
      var wait = root.querySelector('.etn-mi-wait');
      if (wait && wait.parentNode) wait.parentNode.removeChild(wait);
      if (!root.querySelector('.etn-mi-veil')) {
        root.innerHTML =
          '<div class="etn-mi-veil" aria-hidden="true"></div>' +
          '<div class="etn-mi-burst" aria-hidden="true"></div>' +
          '<div class="etn-mi-card"></div>';
      }
      return root;
    }
    root = document.createElement('div');
    root.id = ROOT_ID;
    root.setAttribute('aria-hidden', 'false');
    root.innerHTML =
      '<div class="etn-mi-veil" aria-hidden="true"></div>' +
      '<div class="etn-mi-burst" aria-hidden="true"></div>' +
      '<div class="etn-mi-card"></div>';
    (document.body || document.documentElement).appendChild(root);
    return root;
  }

  function clearIntroTimers() {
    if (hideTimer) window.clearTimeout(hideTimer);
    if (leaveTimer) window.clearTimeout(leaveTimer);
    if (settleTimer) window.clearTimeout(settleTimer);
    hideTimer = null;
    leaveTimer = null;
    settleTimer = null;
  }

  function cancelAnims() {
    for (var i = 0; i < runningAnims.length; i++) {
      try {
        runningAnims[i].cancel();
      } catch (e) {}
    }
    runningAnims = [];
  }

  function clearPending() {
    try {
      document.documentElement.classList.remove('etn-mi-hold');
      document.body.classList.remove('etn-mi-pending', 'etn-mi-hold');
    } catch (e) {}
  }

  function mountStage(root) {
    root.classList.add('is-on');
    root.classList.remove('is-off', 'is-leaving');
    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    root.style.display = 'flex';
    root.style.opacity = '1';
  }

  function hideIntro() {
    var root = document.getElementById(ROOT_ID);
    if (!root) {
      clearPending();
      return;
    }

    // Commit current frames (do NOT cancel — cancel snaps children back to opacity 0).
    for (var i = 0; i < runningAnims.length; i++) {
      try {
        if (runningAnims[i].playState !== 'finished') runningAnims[i].finish();
      } catch (e) {}
    }
    runningAnims = [];

    if (settleTimer) window.clearTimeout(settleTimer);
    settleTimer = null;
    settleIntroContent(root);

    var finished = false;
    function finishHide() {
      if (finished) return;
      finished = true;
      root.classList.add('is-off');
      root.classList.remove('is-on', 'is-leaving');
      root.style.display = 'none';
      root.style.opacity = '';
      root.style.webkitTransition = '';
      root.style.transition = '';
      root.setAttribute('aria-hidden', 'true');
      var card = root.querySelector('.etn-mi-card');
      if (card) card.innerHTML = '';
      clearPending();
    }

    // Keep the overlay painted, then fade it out with WAAPI (reliable in Safari).
    root.classList.add('is-on');
    root.classList.remove('is-off', 'is-leaving');
    root.style.display = 'flex';
    root.style.pointerEvents = 'none';
    root.style.opacity = '1';

    if (leaveTimer) window.clearTimeout(leaveTimer);

    if (typeof root.animate === 'function') {
      try {
        var fade = root.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 550, easing: 'ease', fill: 'forwards' }
        );
        fade.onfinish = function () {
          finishHide();
        };
        leaveTimer = window.setTimeout(finishHide, 650);
        return;
      } catch (e2) {}
    }

    root.style.webkitTransition = 'opacity .55s ease';
    root.style.transition = 'opacity .55s ease';
    void root.offsetWidth;
    root.style.opacity = '0';
    leaveTimer = window.setTimeout(finishHide, 580);
  }

  /**
   * Do NOT show the empty glow stage. Only keep the page held/hidden
   * until playMatchPremiumIntro mounts the REAL intro with players.
   */
  function showMatchIntroCover() {
    try {
      document.documentElement.classList.add('etn-mi-hold');
      document.body.classList.add('etn-mi-pending', 'etn-mi-hold');
    } catch (e) {}
    var boot = document.getElementById('etn-match-boot');
    if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
    var root = document.getElementById(ROOT_ID);
    if (root) {
      root.classList.add('is-off');
      root.style.display = 'none';
      var card = root.querySelector('.etn-mi-card');
      if (card) card.innerHTML = '';
    }
    return null;
  }

  function hideMatchIntroCover() {
    clearIntroTimers();
    cancelAnims();
    var root = document.getElementById(ROOT_ID);
    if (root) {
      root.classList.add('is-off');
      root.classList.remove('is-leaving');
      root.style.display = 'none';
      root.style.opacity = '';
      root.setAttribute('aria-hidden', 'true');
      var card = root.querySelector('.etn-mi-card');
      if (card) card.innerHTML = '';
    }
    var boot = document.getElementById('etn-match-boot');
    if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
    clearPending();
  }

  function setStart(el, opacity, transform) {
    if (!el) return;
    el.style.opacity = String(opacity);
    el.style.webkitTransform = transform;
    el.style.transform = transform;
  }

  function commitEnd(el, keyframes) {
    if (!el) return;
    var last = keyframes[keyframes.length - 1] || {};
    try {
      if (last.opacity != null) el.style.opacity = String(last.opacity);
      if (last.transform) {
        el.style.webkitTransform = last.transform;
        el.style.transform = last.transform;
      }
    } catch (e) {}
  }

  function animateTo(el, keyframes, opts) {
    if (!el) return null;
    opts = opts || {};
    var duration = opts.duration || 500;
    var delay = opts.delay || 0;
    var easing = opts.easing || 'cubic-bezier(0.22, 1, 0.36, 1)';

    if (typeof el.animate === 'function') {
      var anim = el.animate(keyframes, {
        duration: duration,
        delay: delay,
        easing: easing,
        fill: 'forwards'
      });

      /*
        Safari drops a forwards fill once the animation finishes, which
        snaps the element back to the inline start style (opacity 0).
        Writing the end frame to inline style keeps it on screen.
      */
      var settle = function () {
        commitEnd(el, keyframes);
      };

      try {
        if (typeof anim.addEventListener === 'function') {
          anim.addEventListener('finish', settle);
        } else {
          anim.onfinish = settle;
        }
      } catch (eFinish) {
        anim.onfinish = settle;
      }

      runningAnims.push(anim);
      return anim;
    }

    var end = keyframes[keyframes.length - 1] || {};
    window.setTimeout(function () {
      el.style.webkitTransition =
        'opacity ' + duration + 'ms ' + easing + ', transform ' + duration + 'ms ' + easing;
      el.style.transition =
        'opacity ' + duration + 'ms ' + easing + ', transform ' + duration + 'ms ' + easing;
      if (end.opacity != null) el.style.opacity = String(end.opacity);
      if (end.transform) {
        el.style.webkitTransform = end.transform;
        el.style.transform = end.transform;
      }
    }, delay);
    return null;
  }

  function runIntroMotion(root) {
    cancelAnims();

    var card = root.querySelector('.etn-mi-card');
    var chip = root.querySelector('.etn-mi-chip');
    var mid = root.querySelector('.etn-mi-mid');
    var foot = root.querySelector('.etn-mi-foot');
    var players = root.querySelectorAll('.etn-mi-player');
    var crowns = root.querySelectorAll('.etn-prem-frame');
    var rings = [];
    var mores = root.querySelectorAll('.etn-mi-more');
    var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var crownEase = 'cubic-bezier(0.16, 1, 0.3, 1)';

    setStart(root, 0, 'none');
    setStart(card, 0, 'translateY(18px) scale(0.98)');
    setStart(chip, 0, 'translateY(8px)');
    setStart(mid, 0, 'scale(0.88)');
    setStart(foot, 0, 'translateY(10px)');

    var i;
    for (i = 0; i < players.length; i++) {
      setStart(players[i], 0, 'translateY(24px)');
    }
    for (i = 0; i < crowns.length; i++) {
      setStart(crowns[i], 0, FRAME_CENTER + ' scale(0.72)');
    }
    for (i = 0; i < rings.length; i++) {
      setStart(rings[i], 0, 'scale(0.72)');
    }
    for (i = 0; i < mores.length; i++) {
      setStart(mores[i], 0, 'translateY(10px)');
    }

    void root.offsetWidth;

    // Soft stage fade — avoids a hard pop.
    animateTo(root, [
      { opacity: 0 },
      { opacity: 1 }
    ], { duration: 320, delay: 0, easing: 'ease-out' });

    animateTo(card, [
      { opacity: 0, transform: 'translateY(18px) scale(0.98)' },
      { opacity: 1, transform: 'translateY(0) scale(1)' }
    ], { duration: 780, delay: 40, easing: ease });

    animateTo(chip, [
      { opacity: 0, transform: 'translateY(8px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 620, delay: 140, easing: ease });

    animateTo(mid, [
      { opacity: 0, transform: 'scale(0.88)' },
      { opacity: 1, transform: 'scale(1)' }
    ], { duration: 700, delay: 220, easing: ease });

    for (i = 0; i < players.length; i++) {
      var side = players[i].closest('.etn-mi-side');
      var isB = side && side.classList.contains('is-b');
      var delay = (isB ? 260 : 200) + i * 110;
      animateTo(players[i], [
        { opacity: 0, transform: 'translateY(24px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 780, delay: delay, easing: ease });
    }

    for (i = 0; i < crowns.length; i++) {
      animateTo(crowns[i], [
        { opacity: 0, transform: FRAME_CENTER + ' scale(0.72)' },
        { opacity: 1, transform: FRAME_CENTER + ' scale(1.06)', offset: 0.62 },
        { opacity: 1, transform: FRAME_CENTER + ' scale(1)' }
      ], { duration: 980, delay: 380 + i * 90, easing: crownEase });
    }

    for (i = 0; i < rings.length; i++) {
      animateTo(rings[i], [
        { opacity: 0, transform: 'scale(0.72)' },
        { opacity: 1, transform: 'scale(1)' }
      ], { duration: 820, delay: 360 + i * 80, easing: ease });
    }

    for (i = 0; i < mores.length; i++) {
      animateTo(mores[i], [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 600, delay: 560, easing: ease });
    }

    animateTo(foot, [
      { opacity: 0, transform: 'translateY(10px)' },
      { opacity: 1, transform: 'translateY(0)' }
    ], { duration: 700, delay: 680, easing: ease });

    /*
      Last line of defence: once every entrance is due, pin the whole
      stage to its finished state so nothing can fade back out while
      the intro is still on screen.
    */
    if (settleTimer) window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(function () {
      settleIntroContent(root);
    }, 2200);
  }

  function settleIntroContent(root) {
    if (!root) return;

    var groups = [
      root.querySelectorAll('.etn-mi-card'),
      root.querySelectorAll('.etn-mi-chip'),
      root.querySelectorAll('.etn-mi-mid'),
      root.querySelectorAll('.etn-mi-foot'),
      root.querySelectorAll('.etn-mi-player'),
      root.querySelectorAll('.etn-prem-frame'),
      root.querySelectorAll('.etn-mi-more')
    ];

    for (var g = 0; g < groups.length; g++) {
      var nodes = groups[g];
      for (var n = 0; n < nodes.length; n++) {
        try {
          var done = nodes[n].classList.contains('etn-prem-frame') ? FRAME_CENTER : 'none';
          nodes[n].style.opacity = '1';
          nodes[n].style.webkitTransform = done;
          nodes[n].style.transform = done;
        } catch (e) {}
      }
    }
  }

  function playMatchPremiumIntro(opts) {
    opts = opts || {};
    var matchId = String(opts.matchId || '').trim();
    if (!matchId) {
      hideMatchIntroCover();
      return false;
    }

    var teamAAll = Array.isArray(opts.teamAPlayers) ? opts.teamAPlayers : [];
    var teamBAll = Array.isArray(opts.teamBPlayers) ? opts.teamBPlayers : [];

    // Everyone sees the intro — even with zero Premium in the lobby.
    if (!teamAAll.length && !teamBAll.length) {
      hideMatchIntroCover();
      return false;
    }

    ensureStyles();
    var root = ensureRoot();
    var card = root.querySelector('.etn-mi-card');
    if (!card) {
      hideMatchIntroCover();
      return false;
    }

    clearIntroTimers();
    cancelAnims();

    // Mount players first, then set copy from crowns actually on each side.
    // Rules (straight):
    //   both sides crowned → Premium battle / Crowns collide
    //   only one side crowned → Premium present / A crown rises
    //   nobody crowned → Battle / Good luck
    card.innerHTML =
      '<div class="etn-mi-chip"></div>' +
      '<div class="etn-mi-duel">' +
      sideHtml(teamAAll, 'is-a') +
      '<div class="etn-mi-mid">' +
      '<div class="etn-mi-vs"></div>' +
      '<div class="etn-mi-mid-label"></div>' +
      '</div>' +
      sideHtml(teamBAll, 'is-b') +
      '</div>' +
      '<div class="etn-mi-foot"></div>';

    if (window.ETN && typeof window.ETN.refreshPremiumFrames === 'function') {
      window.ETN.refreshPremiumFrames(card);
    }
    var crownsA = card.querySelectorAll('.etn-mi-side.is-a .etn-has-frame').length;
    var crownsB = card.querySelectorAll('.etn-mi-side.is-b .etn-has-frame').length;
    var bothCrowns = crownsA > 0 && crownsB > 0;
    var hasPremium = crownsA > 0 || crownsB > 0;

    var chip = hasPremium ? 'Premium exclusive' : 'Match lobby';
    var midLabel = bothCrowns ? 'Premium battle' : hasPremium ? 'Premium present' : 'Battle';
    var foot = bothCrowns ? 'Crowns collide' : hasPremium ? 'A crown rises' : 'Good luck';

    var chipEl = card.querySelector('.etn-mi-chip');
    var vsEl = card.querySelector('.etn-mi-vs');
    var midEl = card.querySelector('.etn-mi-mid-label');
    var footEl = card.querySelector('.etn-mi-foot');
    if (chipEl) chipEl.textContent = miT(chip);
    if (vsEl) vsEl.textContent = miT('VS');
    if (midEl) midEl.textContent = miT(midLabel);
    if (footEl) footEl.textContent = miT(foot);

    // Gold stays for Premium lobbies; purple-only when nobody has Premium.
    try {
      root.classList.toggle('is-lobby', !hasPremium);
      root.classList.toggle('is-premium', !!hasPremium);
    } catch (eClass) {}

    try {
      document.body.classList.add('etn-mi-pending');
    } catch (e) {}

    // Mount hidden, then fade + animate content — no hard pop.
    root.style.opacity = '0';
    mountStage(root);
    root.style.opacity = '0';

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        runIntroMotion(root);
      });
    });

    hideTimer = window.setTimeout(hideIntro, 3000);
    return true;
  }

  window.ETN.playMatchPremiumIntro = playMatchPremiumIntro;
  window.ETN.showMatchIntroCover = showMatchIntroCover;
  window.ETN.hideMatchIntroCover = hideMatchIntroCover;
  window.ETN.hasSeenMatchIntro = function () {
    return false;
  };
  window.ETN.collectPremiumPlayers = premiumPlayers;
})();
